const init = () => {
  const cta = document.querySelector('.js-cta');

  window.addEventListener('scroll', () => {
    if (window.scrollY > 100) {
      cta.classList.add('is-visible');
    } else {
      cta.classList.remove('is-visible');
    }
  });
};

export {
    init,
};
